export default __webpack_public_path__ + "static/media/kg5.53e98653.jpg";